import config from "../config";

const api_url = config.api_url;

const requestOptions = (type = 'POST') => {
    return {
        method: type,
        headers: {
            "Content-Type": "application/json"
        }
    }
}

const getEntityPrograms = () => {
    let options = {
        ...requestOptions('GET')
    }
    return fetch(`${api_url}/integration/getentityprograms?token=${sessionStorage.getItem('token')}`, options)
        .then(response => response.json());
}

const createCard = (sso_id, last_four_digits, enrollment_id, card_first_name = null) => {
    const body = {
        sso_id: sso_id,
        last_four_digits: last_four_digits,
        enrollment_id: enrollment_id,
        token: sessionStorage.getItem('token')
    }
    if (card_first_name) body['card_first_name'] = card_first_name;
    let options = {
        ...requestOptions()
    }
    options['body'] = JSON.stringify(body);
    return fetch(`${api_url}/integration/createcard`, options)
        .then(response => response.json());
}

export {
    createCard,
    getEntityPrograms
}